import { combineReducers } from 'redux';
import CONSTANTS from '../constants';
import globalState from '../state';
import { formataDataWebMethodParaString, formataCentavoZerado } from '../modules/util';
import { _createStatePessoa, _mapearPropriedadesPessoa } from '../modules/api';






const progressoFinalizarFiador = (state = globalState.fiadores.progressoFinalizarFiador, action) => {
    if (action.type === CONSTANTS.PROGRESS_FINALIZAR_FIADOR) {
        return action.payload.msg;
    }
    if (action.type === CONSTANTS.PROGRESS_FINALIZAR_FIADOR.ERROR) {
        return "";
    }
    
    return state
};


const envioDeFiadoresConcluidoComSucesso = (state = globalState.fiadores.envioDeFiadoresConcluidoComSucesso, action) => {
    let payload = action.payload;
    if (action.type === CONSTANTS.CONCLUIR_ENVIO_FIADORES.SUCCESS) {
        return payload.msgSucesso;
    }
    return state
};

const indexAbaFiador = (state = globalState.fiadores.indexAbaFiador, action) => {
    var payload = action.payload;
    var acoes = {
        [CONSTANTS.SET_INDEX_ABAFIADOR]: () => {
            return payload.indexAbaFiador;
        }
    };
    if (acoes[action.type]) {
        return acoes[action.type]();
    }
    return state;
};

const concluindo = (state = globalState.fiadores.concluindo, action) => {
    var payload = action.payload;
    var acoes = {
        [CONSTANTS.CONCLUIR_ENVIO_FIADORES.LOADING]: () => {
            return true;
        },
        [CONSTANTS.CONCLUIR_ENVIO_FIADORES.SUCCESS]: () => {
            return false;
        },
        [CONSTANTS.CONCLUIR_ENVIO_FIADORES.ERROR]: () => {
            return false;
        }
    };

    if (acoes[action.type]) {
        return acoes[action.type]();
    }
    return state;
};
const carregandoForm = (state = globalState.fiadores.carregandoForm, action) => {
    var payload = action.payload;
    var acoes = {
        [CONSTANTS.GET_DADOS_FORM_FIADORES.LOADING]: () => {
            return true;
        },
        [CONSTANTS.GET_DADOS_FORM_FIADORES.SUCCESS]: () => {
            return false;
        },
        [CONSTANTS.GET_DADOS_FORM_FIADORES.ERROR]: () => {
            return false;
        }
    };

    if (acoes[action.type]) {
        return acoes[action.type]();
    }
    return state;
};

const dadosSolicitacao = (state = globalState.fiadores.dadosSolicitacao, action) => {
    var payload = action.payload;
    var acoes = {
        [CONSTANTS.GET_DADOS_FORM_FIADORES.SUCCESS]: () => {
            var dadosSolicitante = payload.dadosSolicitacao.dados[0];
            let maiorDeIdade = payload.dadosSolicitacao.maiorDeIdade;
            let solSeq = Number(dadosSolicitante["sol_seq"]);
            return {
                ...state,
                solSeq: solSeq,
                maiorDeIdade: maiorDeIdade,
                pesNome: dadosSolicitante.pes_nome.trim(),
                pesCPF: dadosSolicitante.pes_cpf
            };
        }
    };
    if (acoes[action.type]) {
        return acoes[action.type]();
    }
    return state;
};

const listFiadores = (state = globalState.fiadores.listFiadores, action) => {
    let payload = action.payload;

    let acoesPessoaGenerico = _createReducerPessoaGenerico(state, action);
    let acoes = {

        [CONSTANTS.ADD_FORM_FIADOR]: () => {
            return [...state, action.payload.fiador];
        },

        [CONSTANTS.REMOVE_FORM_FIADOR]: () => {
            return state.filter((item, indice) => {
                return indice != payload.indice;
            });
        },

        [CONSTANTS.GET_DADOS_FORM_FIADORES.SUCCESS]: () => {
            // var listFiadores = [{}, {},{}, {}]; //payload.listFiadores;
        
            let listFiadores = payload.listFiadores;
            let list = [...state];
            listFiadores.forEach((item, indice) => {
                let servidorParaClient = true;

               // item = _mapearPropriedadesPessoa(item, servidorParaClient);                
                list[indice] = { ...list[indice], ...item };
            });
            return list;
        }
    };
    let isActionFiador = action.payload && typeof action.payload.indiceFiador === 'number' && action.payload.indiceFiador >= 0;
    if (isActionFiador) {
        acoes = { ...acoes, ...acoesPessoaGenerico };
    }
    if (acoes[action.type]) {
        return acoes[action.type]();
    }
    return state;
};

const dadosResponsavel = (state = globalState.fiadores.dadosResponsavel, action) => {
    // console.log(action, state);
    var payload = action.payload;

    let acoesPessoaGenerico = _createReducerPessoaGenerico(state, action);

    var acoes = {
        [CONSTANTS.GET_DADOS_FORM_FIADORES.SUCCESS]: () => {
            var dadosResponsavel = payload.dadosResponsavel;
            if (dadosResponsavel) {
                return { ...state, ...dadosResponsavel };
            }
            return null;
        },
        ...acoesPessoaGenerico
    };

    let isActionFiador = action.payload && typeof action.payload.indiceFiador === 'number' && action.payload.indiceFiador >= 0;

    if (!isActionFiador && acoes[action.type]) {
        return acoes[action.type]();
    }
    return state;
};

const _createReducerPessoaGenerico = (state, action, isResponsavel) => {
    let payload = action.payload;


    let _getNovoState = (alteracaoItem) => {
        let isActionFiador = action.payload && typeof action.payload.indiceFiador === 'number' && action.payload.indiceFiador >= 0;
        //responsavel ou conjuge do responsavel
        if (!isActionFiador) {
            if (payload.tipoPessoa === CONSTANTS._TIPO_PESSOA.RESPONSAVEL) {

                return { ...state, ...alteracaoItem };
            }
            if (payload.tipoPessoa === CONSTANTS._TIPO_PESSOA.CONJUGE) {
                var obj = { ...state };
                obj.conjuge = {
                    ...obj.conjuge,
                    ...alteracaoItem
                };
                return obj;
            }

            return state;
        }

        let listFiadores = [...state];
        let itemFinal = listFiadores[action.payload.indiceFiador];

        if (payload.tipoPessoa === CONSTANTS._TIPO_PESSOA.CONJUGE) {
            listFiadores[action.payload.indiceFiador].conjuge = {
                ...itemFinal.conjuge,
                ...alteracaoItem
            };
        } else {
            listFiadores[action.payload.indiceFiador] = {
                ...itemFinal,
                ...alteracaoItem
            };
        }
        return listFiadores;
    };

    var acoes = {
        [CONSTANTS.CHANGE_CAMPO_GENERICO_FIADOR]: () => {
            let obj = {
                [payload.campoState]: payload.valor
            };
            if (payload.campoState === "pesRendaBruta") {
                obj[payload.campoState] = formataCentavoZerado(obj[payload.campoState]);//obj[payload.campoState] && obj[payload.campoState].toString().replace(/\./gim, ",");

            }
            return _getNovoState(obj);
        },

        [CONSTANTS.EDITAR_FIADOR_CPF]: () => {
            return _getNovoState({
                cpfOK: false
            });
        },

        [CONSTANTS.GET_DADOS_FORM_FIADORES_CPF.ERROR]: () => {
            return _getNovoState({
                carregandoPessoaCPF: false
            });
        },

        [CONSTANTS.GET_DADOS_FORM_FIADORES_CPF.LOADING]: () => {
            return _getNovoState({
                carregandoPessoaCPF: true
            });
        },

        [CONSTANTS.CONSULTA_CEP_FIADOR.LOADING]: () => { return _getNovoState({ carregandoCEP: true }); },

        [CONSTANTS.CONSULTA_CEP_FIADOR.ERROR]: () => { return _getNovoState({ carregandoCEP: false }); },

        [CONSTANTS.CONSULTA_CEP_FIADOR.SUCCESS]: () => {
            let dadosCEP = payload.dadosCEP;
            var cep = {
                pesBairro: dadosCEP.bairro.toUpperCase(),
                pesRua: dadosCEP.rua.toUpperCase(),
                uf: dadosCEP.uf.toUpperCase(),
                cidadeCEP: dadosCEP.cidade.toUpperCase()
            };

            if (payload.dadosCEP.locCodigo) {
                cep.locCodigo = payload.dadosCEP.locCodigo;
               
            }
            if(payload.dadosCEP.listCidades){
                cep.listCidades = payload.dadosCEP.listCidades;
            }
            return _getNovoState({
                ...cep,
                carregandoCEP: false
            });
        },

        [CONSTANTS.GET_DADOS_FORM_FIADORES_CPF.SUCCESS]: () => {
            var dadosPessoa = payload.dados.dadosPessoa;
            var permissaoAlterar = payload.dados.permissaoAlterar;
            let bloquearTudo = payload.dados.bloquearTudo;
            var pessoa = _createStatePessoa(payload.tipoPessoa);
           
            //remove o cpf pois nao vamos zerar ele
            //ele sera reaproveitado  
            delete pessoa.pesCPF;
            //caso tenha na base de dados entao preeencher 
            if (dadosPessoa) {
                pessoa = { ...pessoa, ..._mapearPropriedadesPessoa(dadosPessoa, true) };
            }
         
            let ret = _getNovoState({
                ...pessoa,
                cpfOK: true,
                carregandoPessoaCPF: false,
                permissaoAlterar: permissaoAlterar,
                bloquearTudo: bloquearTudo
            });
            return ret;
        },

        [CONSTANTS.CARREGAR_LIST_CIDADES_FIADOR.LOADING]: () => {
            return _getNovoState({
                carregandoCidades: true
            });
        },

        [CONSTANTS.CARREGAR_LIST_CIDADES_FIADOR.SUCCESS]: () => {
            let ret = _getNovoState({
                carregandoCidades: false,
                listCidades: payload.listCidades
            });
            console.log('#############', ret);
            return ret;
        },

        [CONSTANTS.CARREGAR_LIST_CIDADES_FIADOR.ERROR]: () => {
            return _getNovoState({
                carregandoCidades: false
            });
        },

        [CONSTANTS.ERROR_PESSOA_FIADOR]: () => {
            return _getNovoState({
                campoErros: payload.campoErros
            });
        },

        [CONSTANTS.ERROR_PESSOA_FIADOR_LIMPAR]: () => {
            return _getNovoState({
                campoErros: {}
            });
        },

    };

    return acoes;
};



const listArquivosSeq = (state = globalState.fiadores.listArquivosSeq, action) => {
    let payload = action.payload;
    if (action.type === CONSTANTS.GET_DADOS_FORM_FIADORES.SUCCESS) {
        return payload.listArquivosSeq;
    }
    return state
};

 
const listArquivos = (state = globalState.fiadores.listArquivos, action) => {
    var payload = action.payload;
    var acoes = {

        [CONSTANTS.GET_DADOS_FORM_FIADORES.SUCCESS]: () => {
            return payload.listArquivos.map((item) => {
                return { ...item, UplArquivo: item.UplBytes };
            });
        },

        [CONSTANTS.ADD_ITEM_ARQUIVO_FIADOR]: () => {
            return [...state, {
                UplOrigem: 'F'.charCodeAt(0),
                UplDescricao: payload.UplDescricao,
                UplArquivo: payload.UplArquivo,//bytes
            }];
        },

        [CONSTANTS.REMOVE_ITEM_ARQUIVO_FIADOR]: () => {
            return state.filter((item, indice) => {
                return indice !== payload.indice;
            });
        },

        [CONSTANTS.UPDATE_ITEM_ARQUIVO_FIADOR]: () => {
            return state.map((item, indice) => {
                return indice !== payload.indice ? item : {
                    UplOrigem: 'F'.charCodeAt(0),
                    UplDescricao: payload.UplDescricao,
                    UplArquivo: payload.UplArquivo//bytes
                };
            })
        }
    };
    if (acoes[action.type]) {
        return acoes[action.type]();
    }
    return state;
};

const fiadores = combineReducers({
    concluindo,
    listArquivos,
    listArquivosSeq,
    indexAbaFiador,
    carregandoForm,
    dadosSolicitacao,
    dadosResponsavel,
    listFiadores,
    envioDeFiadoresConcluidoComSucesso,
    progressoFinalizarFiador
});

export default fiadores;


// WEBPACK FOOTER //
// ./src/reducers/fiadores.js